var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedSectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 239310"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.8182 56L26.3636 49.9048L19.8182 48.381L20.4545 41.3333L16 36L20.4545 30.6667L19.8182 23.619L26.3636 22.0952L29.8182 16L36 18.7619L42.1818 16L45.6364 22.0952L52.1818 23.619L51.5455 30.6667L56 36L51.5455 41.3333L52.1818 48.381L45.6364 49.9048L42.1818 56L36 53.2381L29.8182 56ZM34.0909 42.7619L44.3636 32L41.8182 29.2381L34.0909 37.3333L30.1818 33.3333L27.6364 36L34.0909 42.7619Z",
    fill: "#ED6E5C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedSectionIcon);
export default __webpack_public_path__ + "static/media/verified-section-icon.62b22435827e078394030b867fd923ff.svg";
export { ForwardRef as ReactComponent };